import { render, staticRenderFns } from "./EditCommission.vue?vue&type=template&id=eb91a1ca&scoped=true"
import script from "./EditCommission.vue?vue&type=script&lang=js"
export * from "./EditCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb91a1ca",
  null
  
)

export default component.exports